import ArrowCircleIcon from 'assets/icons/ArrowCircleIcon';
import CloseIcon from 'assets/icons/CloseIcon';
import DPGallery from 'components/DPGallary';
import EtownGallary from 'components/EtownGallary';
import { useEffect, useMemo, useRef, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import './DPMobileMenu.scss';
import { toggleMenu } from 'store/actions';
import { ROUTE_MAP } from 'consts/url';

function MobileFullRightMenu(props) {
  const { isOpen, menu, onSelect, onClose, scenes, groups } = props;

  const [openIndex, setOpenIndex] = useState(null);
  const childrenRefs = useRef({});
  const [docsOpen, setDocsOpen] = useState(false);
  const [docItems, setDocItems] = useState([]);
  const [showAmenities, setShowAmenities] = useState(false);

  const history = useHistory();

  // Filter out menu items with name "GALLERY" (case-insensitive)
  const filteredMenu = useMemo(() => {
    return menu?.filter?.(
      (item) => item?.name?.toLowerCase?.() !== 'gallery'
    ) || [];
  }, [menu]);

  const dispatch = useDispatch();

  const handleMapClick = () => {
    history.push('/map');
    onClose();
  };
  const isGalleryTab = useMemo(() => {
    const pathname = window.location.pathname;
    return pathname === '/gallery' || pathname.startsWith('/gallery/');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [window.location.pathname]);

  const isAmenitiesTab = useMemo(() => {
    return window.location.pathname === `/${ROUTE_MAP.amenities.id}`;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [window.location.pathname]);

  const toggleGroup = (index, hasScenes) => {
    const menuItem = filteredMenu[index];
    const isDocs = !hasScenes || /liệu/i.test(menuItem?.name || '');
    const isAmenities = menuItem?.name?.toLowerCase().includes('amenities');

    if (isDocs) {
      setDocItems(
        scenes.map((item) => ({
          id: item.id,
          title: item.title,
          coverImage: item.previewImgUrl,
        }))
      );
      setDocsOpen(true);
      history.push('/gallery');
      setOpenIndex(null);
      setShowAmenities(false);
      return;
    }

    if (isAmenities) {
      setShowAmenities(true);
      history.push(`/${ROUTE_MAP.amenities.id}`);
      setOpenIndex(null);
      setDocsOpen(false);
      return;
    }

    if (!hasScenes) return;
    setOpenIndex((prev) => (prev === index ? null : index));
  };

  useEffect(() => {
    Object.keys(childrenRefs.current).forEach((k) => {
      const idx = Number(k);
      const el = childrenRefs.current[k];
      if (!el) return;
      if (idx === openIndex) {
        const target = el.scrollHeight;
        el.style.height = target + 'px';
      } else {
        el.style.height = '0px';
      }
    });
  }, [openIndex, filteredMenu]);

  useEffect(() => {
    if (isGalleryTab) {
      setDocsOpen(true);
      dispatch(toggleMenu(true));
    }
  }, [dispatch, isGalleryTab]);

  useEffect(() => {
    if (isAmenitiesTab) {
      setShowAmenities(true);
      dispatch(toggleMenu(true));
    }
  }, [dispatch, isAmenitiesTab]);

  return (
    <div className={`MobileFullRightMenu ${isOpen ? 'open' : 'close'}`}>
      <div className="MobileFullRightMenu--container">
        <div className="MobileFullRightMenu--header">
          <div className="MobileFullRightMenu--header__wrapper">
            <img src="/assets/images/logo/etown_logo.png" alt="logo" />
          </div>
        </div>
        <div className="MobileFullRightMenu--body">
          <div className="MobileFullRightMenu--body_groups">
            <div
              className="MobileFullRightMenu--body_groups_item"
              onClick={handleMapClick}
            >
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: '100%',
                }}
              >
                <span className="MobileFullRightMenu--body_groups_item__title">
                  Map
                </span>
              </div>
            </div>
            {filteredMenu.map((group, i) => {
              const hasScenes =
                Array.isArray(group.scenes) && group.scenes.length > 0;
              const isOpen = openIndex === i;
              const isMuted = openIndex !== null && i !== openIndex;
              const isAmenities = group.name
                ?.toLowerCase()
                .includes('amenities');
              return (
                <div
                  key={i}
                  className={`MobileFullRightMenu--body_groups_item ${
                    isOpen ? 'open' : ''
                  } ${isMuted ? 'muted' : ''}`}
                  onClick={() => toggleGroup(i, hasScenes)}
                >
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      width: '100%',
                    }}
                  >
                    <span className="MobileFullRightMenu--body_groups_item__title">
                      {group.name === 'Tài Liệu' ? 'Tài liệu' : group.name}
                    </span>
                    {hasScenes && !isAmenities ? (
                      <div
                        style={{
                          transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                          transition: 'transform 0.3s ease',
                          height: '15px',
                        }}
                      >
                        <ArrowCircleIcon
                          color={`${isMuted ? '#ced2da' : 'black'}`}
                          height={15}
                          width={15}
                        />
                      </div>
                    ) : null}
                  </div>
                  {hasScenes && !isAmenities ? (
                    <div
                      className={`MobileFullRightMenu--body_groups_item__children ${
                        group.scenes.length > 10 ? 'limit-height' : ''
                      }`}
                      ref={(el) => (childrenRefs.current[i] = el)}
                    >
                      {group.scenes.map((scene) => (
                        <div
                          key={scene.id}
                          className="MobileFullRightMenu--body_groups_item__child"
                          onClick={() => {
                            onSelect(scene.groupId, scene._id);
                            onClose();
                          }}
                        >
                          <span>{scene.title}</span>
                        </div>
                      ))}
                    </div>
                  ) : null}
                </div>
              );
            })}
          </div>
        </div>
        <div
          className="MobileFullRightMenu--footer__wrapper"
          onClick={() => {
            onClose();
            (window.location.pathname.includes(`/${ROUTE_MAP.amenities.id}`) ||
              window.location.pathname.includes(`/gallery`)) &&
              history.push(`/${ROUTE_MAP.overview.id}`);
          }}
        >
          <CloseIcon />
          <p>CLOSE</p>
        </div>
      </div>
      {docsOpen && (
        <div className="dpdoc-overlay">
          <div className="dpdoc-overlay__header">
            <button
              className="button active"
              onClick={() => setDocsOpen(false)}
            >
              <CloseIcon color="white" width={20} height={20} />
            </button>
          </div>
          <DPGallery
            items={docItems}
            onClose={() => setDocsOpen(false)}
            onCloseMenu={onClose}
          />
        </div>
      )}
      {showAmenities && (
        <EtownGallary
          items={
            filteredMenu
              .find((item) => item.name?.toLowerCase().includes('amenities'))
              ?.scenes?.map((scene) => ({
                id: scene._id,
                title: scene.title,
                coverImage: scenes.find((s) => s._id === scene._id)
                  ?.previewImgUrl,
                tourGroupName: groups?.find(
                  (g) =>
                    g._id === scenes.find((s) => s._id === scene._id)?.tourGroupId
                )?.title,
              })) || []
          }
          onClose={() => setShowAmenities(false)}
          onCloseMenu={onClose}
        />
      )}
    </div>
  );
}

const mapStateToProps = ({ hotspotHistory, currentScene, json }) => ({
  panoId: currentScene.id,
  historyLogs: hotspotHistory,
  tour: json.tour,
});

export default connect(mapStateToProps)(MobileFullRightMenu);
